import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { PhoneContainer } from 'shared/containers/BottomAuthorBlockNew/PhoneContainer';
import { getCallButtonText } from 'shared/utils/getCallButtonText';

import { trackCallButtonClick } from './tracking';
import { getGaLabel, getOffer } from '../../selectors/newObject';

interface IPurchaseTermsCallButtonProps {
  modalType: 'prices_modal' | 'purchase_term_modal';
}

export const PurchaseTermsCallButton = ({ modalType }: IPurchaseTermsCallButtonProps) => {
  const [phonesVisible, handlePhonesVisible] = React.useState(false);

  const gaLabel = useSelector(getGaLabel);
  const offer = useSelector(getOffer);

  const handleShowPhoneClick = React.useCallback(() => {
    handlePhonesVisible(true);

    trackCallButtonClick({ gaLabel, modalType });
  }, [gaLabel, modalType]);

  if (phonesVisible) {
    return <PhoneContainer placeType="different_price" />;
  }

  return (
    <Button
      data-testid="PurchaseTermsCallButton"
      theme="fill_primary"
      size="M"
      onClick={handleShowPhoneClick}
      tabIndex={-1}
    >
      {getCallButtonText(offer)}
    </Button>
  );
};
